import { styled } from '@mui/material/styles';

export const RealmAssignmentsContainer = styled('div')({
  maxWidth: 1100,
  width: '100%',
  margin: '0 auto',
});
